document.addEventListener('DOMContentLoaded', () => {
  const neighborhood = document.querySelector('#CartAttributeNeighborhood');
  const birthday = document.querySelector('#CartAttributeBirthday');
  const cartForm = document.querySelector('form[action="/cart"]');

  if (!neighborhood || !birthday) return;

  let saveTimeout;

  async function saveCartAttributes() {
    clearTimeout(saveTimeout);

    saveTimeout = setTimeout(async () => {
      try {
        const response = await fetch(
          window.Shopify.routes.root + 'cart/update.js',
          {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'Accept': 'application/json'
            },
            body: JSON.stringify({
              attributes: {
                Barrio: neighborhood.value.trim(),
                cumpleanos: birthday.value
              }
            })
          }
        );

        if (!response.ok) {
          throw new Error('No se pudieron guardar los datos.');
        }

      } catch (error) {
        console.error('Error guardando los datos:', error);
      }
    }, 300);
  }

  neighborhood.addEventListener('input', saveCartAttributes);
  birthday.addEventListener('change', saveCartAttributes);

  if (cartForm) {
    cartForm.addEventListener('submit', async (event) => {
      if (!neighborhood.value.trim()) {
        event.preventDefault();

        neighborhood.setCustomValidity('Por favor, ingresa tu barrio.');
        neighborhood.reportValidity();

        return;
      }

      neighborhood.setCustomValidity('');

      clearTimeout(saveTimeout);

      try {
        await fetch(
          window.Shopify.routes.root + 'cart/update.js',
          {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'Accept': 'application/json'
            },
            body: JSON.stringify({
              attributes: {
                Barrio: neighborhood.value.trim(),
                cumpleanos: birthday.value
              }
            })
          }
        );

        console.log('Datos de entrega guardados antes del checkout.');

      } catch (error) {
        console.error('Error guardando los datos antes del checkout:', error);
      }
    });
  }
});